import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import "./assests/css/custom.css";
import "./assests/css/style.css";
import "./assests/css/font.css";
import "./assests/css/main.css";
import "./assests/css/bootstrap.css";
import "leaflet/dist/leaflet.css";

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById("root")
);
